/**
 * @namespace Loader
 * @aka COMMON.Loader
 *
 */
COMMON.Loader = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'loader';
  var DATA_KEY = 'common.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Events = {
    LOADER_SHOW: 'loader.show' + EVENT_KEY + DATA_API_KEY,
    LOADER_HIDE: 'loader.hide' + EVENT_KEY + DATA_API_KEY
  };
  var Selector = {
    DATA_SPY: '#loader'
  };

  var Default = {
    container: '#content'
  };

  var DefaultType = {
    container: 'string'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Loader = function () {

    function Loader(element, config) {
      if (!(this instanceof Loader)) {
        throw new TypeError("Cannot call a class as a function");
      }

      var self = this;

      // protected
      self.element = element;

      self.config = self._getConfig(config);

      // Eventlisteners
      $(document).on(Events.LOADER_SHOW, function (event, config) {
        self.show();
      });
      $(document).on(Events.LOADER_HIDE, function () {
        self.hide()
      });
    }

    // private
    Loader.prototype._getConfig = function _getConfig(config) {
      config = Object.assign({}, Default, config);

      COMMON.Utils.typeCheckConfig(NAME, config, DefaultType);

      return config;
    };

    Loader.prototype.show = function show() {
      var self = this;

      var $loader = $(self.element);
      $loader.attr('aria-hidden', 'false');

      var $container = $(self.config.container);
      if ($container.length > 0) {
        $container.attr('aria-busy', 'true');
      }

      $('body').addClass('loading')
    };

    Loader.prototype.hide = function hide() {
      var self = this;

      var $loader = $(self.element);
      $loader.attr('aria-hidden', 'true');

      var $container = $(self.config.container);
      if ($container.length > 0) {
        $container.attr('aria-busy', 'false');
      }

      $('body').removeClass('loading')
    };

    // public
    Loader.prototype.dispose = function dispose() {
      $(this._element).off(EVENT_KEY);
      this.element = null;

      $(document).off(EVENT_KEY);
      $(window).off(EVENT_KEY);
    };

    // static
    Loader._jQueryInterface = function _jQueryInterface() {
      return this.each(function() {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new Loader(this);
          $(this).data(DATA_KEY, data);
        }
      });
    };

    return Loader;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $loader = $(this);
    Loader._jQueryInterface.call($loader);
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Loader._jQueryInterface;
  $.fn[NAME].Constructor = Loader;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Loader._jQueryInterface;
  };

  return Loader;

}(window.jQuery);
